export function getIconClasses(iconClass) {
  return ['glyphicon', 'toolbar-icon', iconClass];
}

export function getLeftIconClasses(iconClass) {
  const classes = getIconClasses(iconClass);

  classes.push('toolbar-icon-left');
  return classes;
}

export const filterIcon = getLeftIconClasses('icon-filter-normal');
export const columnChooserIcon = getLeftIconClasses('icon-columnchooser-normal');
export const downloadIcon = getLeftIconClasses('icon-export-normal');
export const arrowDownIcon = getIconClasses('glyphicon-triangle-bottom');
export const expandIcon = getIconClasses('grid-expand-icon');
